<body>
  <app-vhs></app-vhs>
  
    <main class="fadeIn">
        <p class="index">
            {{ totalVideos ? currentIndex + 1 : 0 }} / {{ totalVideos }}
        </p>
          
        <div class="aside">
            <mat-accordion>
                <mat-expansion-panel class="transparent-panel" hideToggle>
                    <mat-expansion-panel-header 
                        collapsedHeight="44px"
                        expandedHeight="44px"
                        matTooltip="Palette" 
                        matTooltipShowDelay="500" 
                        matTooltipPosition="right" 
                        aria-label="Expand Palette Colors" 
                        role="button" 
                        tabindex="0">
                        <mat-panel-title class="theme-panel-title">
                            <mat-icon class="theme-palette-icon" aria-label="Palette">palette</mat-icon>
                            <mat-icon *ngIf="hasNewThemes" class="theme-new-warning" aria-hidden="true">
                              new_releases
                            </mat-icon>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="theme-buttons" aria-label="Selecionar tema">
                      <span class="theme-option" *ngFor="let theme of themeOptions">
                        <button
                          class="colors"
                          type="button"
                          [style.background-color]="getThemeSwatch(theme)"
                          (click)="setTheme(theme.id)"
                          (mouseenter)="markThemeAsSeen(theme.id)"
                          (focus)="markThemeAsSeen(theme.id)"
                          [attr.aria-label]="'Tema ' + theme.name + (isThemeNew(theme.id) ? ', novo' : '')"
                          [attr.aria-pressed]="selectedPalette === theme.id"
                          [matTooltip]="theme.name"
                          matTooltipPosition="right"
                        ></button>
                        <span class="theme-new-label" *ngIf="isThemeNew(theme.id)">NEW!</span>
                      </span>
                    </div>                    
                </mat-expansion-panel>
            </mat-accordion> 
        </div>
        <nav class="adm" aria-label="Site controls">
            <button
              class="utility-button"
              type="button"
              mat-icon-button
              (click)="toggleFullScreen()"
              [matTooltip]="isFullScreen ? 'Exit Full Screen' : 'Full Screen'"
              matTooltipShowDelay="500"
              matTooltipPosition="below"
              [attr.aria-label]="isFullScreen ? 'Exit full screen' : 'Enter full screen'"
            >
              <mat-icon aria-hidden="true">
                {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
              </mat-icon>
            </button>
            <button
              #radioListToggle
              class="utility-button list-button"
              type="button"
              mat-icon-button
              (click)="toggleList()"
              matTooltip="Radio List"
              matTooltipShowDelay="500"
              matTooltipPosition="below"
              [attr.aria-label]="hasNewItems ? 'Radio list, new stations available' : 'Radio list'"
              [attr.aria-expanded]="showList"
              aria-controls="radio-list-panel"
            >
              <mat-icon aria-hidden="true">list</mat-icon>
              <mat-icon *ngIf="hasNewItems" class="newWarning" aria-hidden="true">
                new_releases
              </mat-icon>
            </button>
            <button
              class="utility-button share-button"
              type="button"
              mat-icon-button
              (click)="shareSite()"
              matTooltip="Share Lofi Radio"
              matTooltipShowDelay="500"
              matTooltipPosition="below"
              aria-label="Share Lofi Radio"
            >
              <mat-icon aria-hidden="true">share</mat-icon>
            </button>
            <button
              *ngIf="getLogin()"
              class="utility-button"
              type="button"
              mat-icon-button
              (click)="goAdm()"
              matTooltip="Administration"
              matTooltipShowDelay="500"
              matTooltipPosition="below"
              aria-label="Open administration"
            >
              <mat-icon aria-hidden="true">assignment</mat-icon>
            </button>
        </nav>
          
        <div class="musicArea">
            <div class="top">
               <div class="card">
                   <img [src]="randomImage" alt="Random Card">
                    <img [src]="randomImage" alt="Imagem de fundo" fetchpriority="high" class="background" />
                    <img [src]="randomImage" alt="Imagem de fundo" fetchpriority="high" class="background2" />

                  </div>
                  <div *ngIf="currentVideoOwner" class="video-owner">
                      <p>{{ currentVideoOwner }}</p>
                  </div>
                <div class="title fadeIn">
                    <h2>
                        <ng-container *ngIf="currentVideoTitle; else stationTitleLoading">
                          {{ currentVideoTitle }}
                        </ng-container>
                        <ng-template #stationTitleLoading>
                          <span class="title-skeleton" aria-hidden="true"></span>
                          <span class="sr-only">Loading station details</span>
                        </ng-template>
                    </h2>
                </div>
                <span class="sr-only" role="status" aria-live="polite" aria-atomic="true">
                  {{ radioStatusMessage }}
                </span>
            </div>
            <div class="down">
                <button class="button shuffle" type="button" (click)="shuffle()" [disabled]="!canNavigateStations" matTooltip="Shuffle Radio" matTooltipShowDelay="500" matTooltipPosition="below" aria-label="Shuffle stations">
                    <mat-icon aria-hidden="true">shuffle</mat-icon>
                </button>
                <button
                  class="button back"
                  type="button"
                  (click)="previousVideo()"
                  [disabled]="!canNavigateStations"
                  [class.is-auto-advancing]="recoveryDirection === -1"
                  [style.--auto-advance-duration]="autoAdvanceDelayMs + 'ms'"
                  matTooltip="Previous Radio"
                  matTooltipShowDelay="500"
                  matTooltipPosition="below"
                  aria-label="Previous station"
                >
                    <mat-icon aria-hidden="true">skip_previous</mat-icon>
                </button>
                <button
                  class="button pause"
                  type="button"
                  (click)="togglePlayPause()"
                  [class.is-loading]="showPlaySpinner"
                  [class.is-unavailable]="isPlayerControlDisabled && !showPlaySpinner"
                  [attr.aria-label]="playPauseLabel"
                  [attr.aria-busy]="showPlaySpinner"
                  [attr.aria-disabled]="isPlayerControlDisabled"
                >
                    <span
                      *ngIf="showPlaySpinner; else playerControlIconTemplate"
                      class="player-button-spinner"
                      aria-hidden="true"
                    ></span>
                    <ng-template #playerControlIconTemplate>
                      <mat-icon aria-hidden="true">{{ playerControlIcon }}</mat-icon>
                    </ng-template>
                </button>
                <button
                  class="button next"
                  type="button"
                  (click)="nextVideo()"
                  [disabled]="!canNavigateStations"
                  [class.is-auto-advancing]="recoveryDirection === 1"
                  [style.--auto-advance-duration]="autoAdvanceDelayMs + 'ms'"
                  matTooltip="Next Radio"
                  matTooltipShowDelay="500"
                  matTooltipPosition="below"
                  aria-label="Next station"
                >
                    <mat-icon aria-hidden="true">skip_next</mat-icon>
                </button>
                
                <button
                    class="button heart"
                    type="button"
                    matTooltip="Favorite Radio"
                    matTooltipShowDelay="500"
                    matTooltipPosition="below"
                    (click)="favorite(currentIndex, $event)"
                    [disabled]="!canFavoriteCurrentStation"
                    [attr.aria-label]="favorites[currentIndex] ? 'Remove station from favorites' : 'Add station to favorites'"
                    >
                    <mat-icon aria-hidden="true">
                        {{ favorites[currentIndex] ? 'favorite' : 'favorite_border' }}
                    </mat-icon>
                </button>

            </div>
            <div class="volume">
                <input 
                  type="range" 
                  id="volume-slider" 
                  min="0" 
                  max="100" 
                  step="1" 
                  [(ngModel)]="volume"
                  (ngModelChange)="setVolume($event)" 
                  [style.background]="getSliderBackground()"
                  [matTooltip]="'' + volume"
                  matTooltipShowDelay="500" 
                  matTooltipPosition="above"
                  aria-label="Volume control"
                />
              </div>               
              
              <div
                #radioListPanel
                id="radio-list-panel"
                class="list"
                [class.show]="showList"
                [attr.aria-hidden]="!showList"
                [attr.inert]="showList ? null : ''"
              >
                <mat-list class="video-list">
                    <mat-list-item *ngFor="let title of videoTitles; let i = index" (mouseenter)="markAsSeen(i)">
                    <!-- label NEW aparece só se não for primeira visita e newItems[i] true -->
                    <p *ngIf="!isFirstVisit && newItems[i]" class="new-label">NEW</p>
                    <div class="station-row">
                      <button
                        class="station-favorite"
                        type="button"
                        (click)="favorite(i, $event)"
                        [attr.aria-pressed]="favorites[i]"
                        [attr.aria-label]="favorites[i] ? 'Remove ' + title + ' from favorites' : 'Add ' + title + ' to favorites'"
                      >{{ favorites[i] ? '♥' : '♡' }}</button>
                      <button
                        class="clickable-title"
                        type="button"
                        (click)="selectVideo(i)"
                        (focus)="markAsSeen(i)"
                        [attr.aria-current]="currentIndex === i ? 'true' : null"
                      >
                      <span class="station-title">{{ i + 1 }}. {{ title }}</span>
                      </button>
                    </div>
                    <div class="border"></div>
                </mat-list-item>
                </mat-list>
              </div>
        </div>

        <div *ngIf="showPlayer && playerMountContext as playerMount" class="youtube-player-host" aria-hidden="true" inert>
          <youtube-player
              [videoId]="playerMount.videoId"
              [disableCookies]="true"
              [playerVars]="playerVars"
              [height]="250"
              [width]="500"
              (ready)="onPlayerReady($event, playerMount.attempt)"
              (stateChange)="onPlayerStateChange($event, playerMount.attempt)"
              (error)="onPlayerError($event, playerMount.attempt)">
          </youtube-player>
        </div>

        <div class="emoji-container">
            <div class="emojibutton" (click)="addEmoji('♥')">
              <span style="color: var(--clr-secondary);">♥</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('♡')">
              <span style="color: var(--clr-secondary);">♡</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('✦')">
              <span style="color: var(--clr-secondary);">✦</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('✧')">
              <span style="color: var(--clr-secondary);">✧</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('♫')">
              <span style="color: var(--clr-secondary);">♫</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('♪')">
              <span style="color: var(--clr-secondary);">♪</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('★')">
                <span style="color: var(--clr-secondary);">★</span>
            </div>
            <div class="emojibutton" (click)="addEmoji('☆')">
                <span style="color: var(--clr-secondary);">☆</span>
            </div>
        </div>

        <div class="footer">
            <div class="left">
                <a class="icon" 
                    href="https://github.com/emanuelsacoman" 
                    target="_blank" 
                    matTooltip="Author" 
                    matTooltipShowDelay="500" 
                    matTooltipPosition="above" 
                    aria-label="Author">
                    <mat-icon>code</mat-icon>
                </a>
                <!-- <a class="icon" 
                    href="https://codebucketweb.web.app" 
                    target="_blank" 
                    matTooltip="CodeBucket" 
                    matTooltipShowDelay="500" 
                    matTooltipPosition="above" 
                    aria-label="CodeBucket">
                    <img src="./assets/image/codebucket.webp" alt="CodeBucket">
                </a> -->

                <div class="usercount" matTooltip="Others Listening" matTooltipShowDelay="500" matTooltipPosition="above">
                    <mat-icon>person</mat-icon>
                    {{ connectedUsersCount }}
                </div>                  
            </div>
              
            <div class="floating-emojis">
                <div *ngFor="let emoji of floatingEmojis" 
                     class="emoji" 
                     [style.left]="emoji.x + 'vw'"
                     [ngStyle]="{
                       '--drift': emoji.drift + 'vw',
                       '--duration': emoji.duration + 's',
                       '--delay': emoji.delay + 's',
                       '--scale': emoji.scale,
                       '--spin': emoji.spin + 'deg',
                       '--glow': emoji.glow,
                       '--trail-opacity': emoji.trailOpacity
                     }">
                  <span class="emoji-trail emoji-trail--far">{{ emoji.emoji }}</span>
                  <span class="emoji-trail emoji-trail--near">{{ emoji.emoji }}</span>
                  <span class="emoji-symbol">{{ emoji.emoji }}</span>
                </div>
              </div>       
              
            <div class="right">
              <div class="image-query">
                   <input
                     type="text"
                     [(ngModel)]="imageQuery"
                     (keydown.enter)="applyImageQuery()"
                     placeholder="Search Image"
                     aria-label="Search Image"
                     matTooltip="Search Image"
                     matTooltipShowDelay="500"
                     maxlength="30"
                   />
               </div>
                <mat-icon class="icon"  [ngClass]="{'animate': isAnimating}" (click)="triggerAnimation()" matTooltip="Change Wallpaper" matTooltipPosition="above" matTooltipShowDelay="500">
                    autorenew
                </mat-icon>
                <a href="https://www.pexels.com" target="_blank" matTooltip="Images API" matTooltipShowDelay="500" matTooltipPosition="above">
                    <img src="https://images.pexels.com/lib/api/pexels-white.png" alt="Pexels"/>
                </a>
            </div>
        </div>
    </main>
      
</body>
